import { render, staticRenderFns } from "./UploadDefault.vue?vue&type=template&id=40d9553e"
import script from "./UploadDefault.vue?vue&type=script&lang=js"
export * from "./UploadDefault.vue?vue&type=script&lang=js"
import style0 from "./UploadDefault.vue?vue&type=style&index=0&id=40d9553e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports